import { ApiRequest, ApiResponse, fetchDataFromAPITyped } from './api-requests';

export type OAuthBlockedResponse = {
  isOAuth: boolean;
  service?: string;
  message: string;
};

export type PasswordResetRequestResponse = {
  message: string;
  isOAuth?: boolean;
  service?: string;
};

export type PasswordResetResponse = {
  message: string;
  isOAuth?: boolean;
  service?: string;
};

export function parseOAuthBlockedPayload(
  payload: unknown
): OAuthBlockedResponse | null {
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  const data = payload as Record<string, unknown>;
  if (data.isOAuth !== true) {
    return null;
  }
  const message =
    typeof data.message === 'string' ? data.message : '';
  return {
    isOAuth: true,
    service: typeof data.service === 'string' ? data.service : undefined,
    message,
  };
}

export function isOAuthBlockedResponse(
  status: number | undefined,
  payload: unknown
): OAuthBlockedResponse | null {
  if (status !== 403) {
    return null;
  }
  return parseOAuthBlockedPayload(payload);
}

export const requestPasswordReset = async (
  email: string
): Promise<ApiResponse<PasswordResetRequestResponse | null>> => {
  const apiRequest: ApiRequest = {
    route: 'user/requestPasswordReset',
    request: {
      method: 'POST',
      entity: 'user',
      body: { email },
    },
  };
  return fetchDataFromAPITyped<PasswordResetRequestResponse>(apiRequest);
};

export const resetPassword = async (
  token: string,
  newPassword: string
): Promise<ApiResponse<PasswordResetResponse | null>> => {
  const apiRequest: ApiRequest = {
    route: 'user/resetPassword',
    request: {
      method: 'POST',
      entity: 'user',
      body: { token, newPassword },
    },
  };
  return fetchDataFromAPITyped<PasswordResetResponse>(apiRequest);
};

export const checkOAuthStatus = async (
  token: string
): Promise<ApiResponse<OAuthBlockedResponse | PasswordResetResponse | null>> => {
  const apiRequest: ApiRequest = {
    route: 'user/checkOAuthStatus',
    request: {
      method: 'POST',
      entity: 'user',
      body: { token },
    },
  };
  return fetchDataFromAPITyped<OAuthBlockedResponse | PasswordResetResponse>(
    apiRequest
  );
};
